/*
 * Copyright (c) 2024. . Yantodev - All Rights Reserved.
 * @Author  :  yantodev
 * mailto : ekocahyanto007@gmail.com
 * link : https://yantodev.my.id/
 */

export const REQUEST_PAYMENT_TYPES = 'REQUEST_PAYMENT_TYPES';
export const REQUEST_PAYMENT_TYPES_SUCCESS = 'REQUEST_PAYMENT_TYPES_SUCCESS';
export const REQUEST_PAYMENT_TYPES_FAILURE = 'REQUEST_PAYMENT_TYPES_FAILURE';

export const REQUEST_PAYMENT_TYPE = 'REQUEST_PAYMENT_TYPE';
export const REQUEST_PAYMENT_TYPE_SUCCESS = 'REQUEST_PAYMENT_TYPE_SUCCESS';
export const REQUEST_PAYMENT_TYPE_FAILURE = 'REQUEST_PAYMENT_TYPE_FAILURE';

export const REQUEST_ADD_PAYMENT_TYPE = 'REQUEST_ADD_PAYMENT_TYPE';
export const REQUEST_ADD_PAYMENT_TYPE_SUCCESS = 'REQUEST_ADD_PAYMENT_TYPE_SUCCESS';
export const REQUEST_ADD_PAYMENT_TYPE_FAILURE = 'REQUEST_ADD_PAYMENT_TYPE_FAILURE';

export const REQUEST_UPDATE_PAYMENT_TYPE = 'REQUEST_UPDATE_PAYMENT_TYPE';
export const REQUEST_UPDATE_PAYMENT_TYPE_SUCCESS = 'REQUEST_UPDATE_PAYMENT_TYPE_SUCCESS';
export const REQUEST_UPDATE_PAYMENT_TYPE_FAILURE = 'REQUEST_UPDATE_PAYMENT_TYPE_FAILURE';

export const REQUEST_DELETE_PAYMENT_TYPE = 'REQUEST_DELETE_PAYMENT_TYPE';
export const REQUEST_DELETE_PAYMENT_TYPE_SUCCESS = 'REQUEST_DELETE_PAYMENT_TYPE_SUCCESS';
export const REQUEST_DELETE_PAYMENT_TYPE_FAILURE = 'REQUEST_DELETE_PAYMENT_TYPE_FAILURE';


